import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { recognitionServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useStartRecognition = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();

  return useMutation(recognitionCode => recognitionServices.start(recognitionCode), {
    onSuccess: (_data, recognitionCode) => {
      queryClient.invalidateQueries(QUERY_KEYS.useGetRecognitionsKey);
      queryClient.invalidateQueries([QUERY_KEYS.useGetRecognitionKey, recognitionCode]);
      showSuccess({
        message: 'Successfully started your recognition.',
        type: 'toast'
      });
    },
    ...options
  });
};
